import { ReactNode, useEffect } from "react";
import { blueColor } from "../constants/colors";

interface SuccessAlertBoxProps {
  isOpen: boolean;
  onClose: () => void;
  iconSource?: string;
  iconAlt?: string;
  headerText: string;
  subText?: string;
  children?: ReactNode;
  autoCloseDelay?: number;
}

export const SuccessAlertBox = ({
  isOpen,
  onClose,
  subText,
  headerText,
  iconSource,
  iconAlt,
  children,
  autoCloseDelay = 3000,
}: SuccessAlertBoxProps) => {
  // Auto-close the modal after delay if isOpen is true
  useEffect(() => {
    if (isOpen && autoCloseDelay) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose, autoCloseDelay]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg p-6 max-w-md w-full mx-auto shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          {iconSource && (
            <div className="flex justify-center mb-4">
              <img 
                src={iconSource} 
                alt={iconAlt || 'Success icon'} 
                className="h-16 w-16 mx-auto"
              />
            </div>
          )}
          
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            {headerText}
          </h2>
          
          <p className="text-gray-600 mb-6">
            {subText}
          </p>
          
          {children && (
            <div className="mt-4">
              {children}
            </div>
          )}
          
          <button
            onClick={onClose}
            className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
